import './PageFooter.scss';


function PageFooter() {
    return (
        <footer className="footer">
            <div className="footer__wrapper">
                <p className="footer__copyright">&copy; 2021, Collectify & Nigel D'Souza</p>
            </div>
        </footer>
    )
}

export default PageFooter;